import React, { useState, useEffect } from 'react';
import CustomButton from './CustomButton';
import { Mail } from 'lucide-react';

const ComingSoon = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  // Set your launch date here
  const LAUNCH_DATE = new Date('2025-03-01T00:00:00');
  
  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = LAUNCH_DATE - now;
    
    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email');
      return;
    }

    try {
        const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfr2i5aWZbkTylRafkSoCAf7p0XgG8k7V8DKkusmj54mgJQHg/formResponse';
      
      // Create form data
      const formBody = new FormData();
      formBody.append('entry.1163189323', email); // Email field
      formBody.append('entry.204177542', 'Berry Club - Interested Customer'); // Source field

      // Submit to Google Form
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: formBody,
      });

      setIsSubmitted(true);
      setEmail('');
      setError('');
    } catch (error) {
      console.error('Submission error:', error);
      setError('There was an error submitting your email. Please try again.');
    }
  };

  const TimeBlock = ({ value, label }) => (
    <div className="flex flex-col items-center bg-white p-4 rounded-tr-xl rounded-bl-xl shadow-lg">
      <span className="text-2xl md:text-4xl font-bold text-[#8b123b]">{value}</span>
      <span className="text-sm md:text-base text-gray-600">{label}</span>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#40E0E5] to-[#8b123b]/20 py-32">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white/80 backdrop-blur-sm rounded-tr-[40px] rounded-bl-[40px] p-8 md:p-12 shadow-xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold text-[#003B5C] mb-6">
              Berry Club
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-8">
              Something exciting is brewing...
            </p>
            <p className="text-lg text-gray-600">
              Where connections, rewards, and experiences come together to make every moment extraordinary.
            </p>
          </div>

          <div className="mb-12">
            <div className="grid grid-cols-4 gap-4 max-w-xl mx-auto">
              <TimeBlock value={String(timeLeft.days).padStart(2, '0')} label="Days" />
              <TimeBlock value={String(timeLeft.hours).padStart(2, '0')} label="Hours" />
              <TimeBlock value={String(timeLeft.minutes).padStart(2, '0')} label="Minutes" />
              <TimeBlock value={String(timeLeft.seconds).padStart(2, '0')} label="Seconds" />
            </div>
          </div>

          {!isSubmitted ? (
            <div className="max-w-md mx-auto">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    placeholder="Enter your email to get notified"
                    className="w-full pl-10 pr-4 py-2 border-2 border-gray-300 rounded-full focus:border-[#8b123b] focus:ring-1 focus:ring-[#8b123b] focus:outline-none"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                <div className="text-center">
                  <CustomButton type="submit">
                    Notify Me
                  </CustomButton>
                </div>
              </form>
            </div>
          ) : (
            <div className="text-center">
              <p className="text-lg text-[#8b123b] font-medium mb-4">
                Thank you for your interest!
              </p>
              <p className="text-gray-600">
                We'll notify you when Berry Club launches.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;